import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class UserSeatService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_SEAT = '/api/user-seat';
        this.UPGRADE_USER = '/upgrade-user';
        this.GET_SEATS_DETAILS = '/get-seats/{orgId}';
        this.GET_USER_SEAT_LIST = '/list/{orgId}/seat/{seatType}';
        this.GET_USED_USER_SEAT_LIST = '/used/user/list/{orgId}';
        this.GET_USER_SEAT_LIST_BY_USER_ID = '/list/user/{userId}';
        this.GET_SEAT_BY_USER_ID_ORG_ID = '/user/{userId}/{orgId}';
        this.CREATE_FREE_SEAT = '/create/free-seat';
        this.GET_SEATS_DETAILS_BY_SEAT_TYPE = '/get-seats/{orgId}/seat/{seatType}';
        this.GET_SEATS_DETAILS_OF_PM_USER_AND_FREE = '/get-seats/pmuser/freeseat/{orgId}';
    }

    async getUserSeatDetails(orgId) {
        let url = window.location.origin + this.USER_SEAT + this.GET_SEATS_DETAILS;
        url = url
                .replace("{orgId}", orgId);
        try{
            const userSeatDetails = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeatDetails;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserSeatDetailsListByUserId(userId) {
        let url = window.location.origin + this.USER_SEAT + this.GET_USER_SEAT_LIST_BY_USER_ID;
        url = url
                .replace("{userId}", userId);
        try{
            const userSeatDetails = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeatDetails;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserSeatDetailsByOrgIdAndSeatType(orgId, seatType) {
        let url = window.location.origin + this.USER_SEAT + this.GET_SEATS_DETAILS_BY_SEAT_TYPE;
        url = url
                .replace("{orgId}", orgId)
                .replace("{seatType}", seatType);
        try{
            const userSeatDetails = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeatDetails;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserSeatByUserIdAndOrgId(userId, orgId) {
        let url = window.location.origin + this.USER_SEAT + this.GET_SEAT_BY_USER_ID_ORG_ID;
        url = url
                .replace("{userId}", userId)
                .replace("{orgId}", orgId);
        try{
            const userSeat = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeat;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserSeatDetailsByPmUserAndFreeByOrgId(orgId) {
        let url = window.location.origin + this.USER_SEAT + this.GET_SEATS_DETAILS_OF_PM_USER_AND_FREE;
        url = url
                .replace("{orgId}", orgId);
        try{
            const userSeatDetails = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeatDetails;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserSeatListByOrgIdAndSeatType(orgId, seatType) {
        let url = window.location.origin + this.USER_SEAT + this.GET_USER_SEAT_LIST;
        url = url
                .replace("{orgId}", orgId)
                .replace("{seatType}", seatType);
        try{
            const userSeatDetails = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userSeatDetails;
        } catch(err) {
            console.log(err);
        }
    }

    async getUsedUserListByOrgId(orgId) {
        let url = window.location.origin + this.USER_SEAT + this.GET_USED_USER_SEAT_LIST;
        url = url
                .replace("{orgId}", orgId);
        try{
            const usedUserSeatList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return usedUserSeatList;
        } catch(err) {
            console.log(err);
        }
    }

    async upgradeToProUser(userDetails) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.USER_SEAT + this.UPGRADE_USER;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(userDetails)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

}

export default UserSeatService;